// Returns lower codonation suggestions than the regular CodonationCalculator,
// for when we are too shy to ask for lots of monies.
export class CodonationCalculatorModest {
  static defaults = [
    { upto: 500, suggest: 100, prefills: [200, 50, 25] },
    { upto: 1000, suggest: 200, prefills: [300, 100, 50] },
    { upto: 1500, suggest: 250, prefills: [400, 200, 100] },
    { upto: 2000, suggest: 300, prefills: [500, 200, 150] },
    { upto: 2500, suggest: 350, prefills: [500, 250, 200] },
    { upto: 3000, suggest: 400, prefills: [700, 300, 200] },
    { upto: 4000, suggest: 500, prefills: [800, 350, 250] },
    { upto: 5000, suggest: 600, prefills: [900, 400, 300] },
    { upto: 8000, suggest: 700, prefills: [1200, 500, 400] },
    { upto: 10000, suggest: 900, prefills: [1500, 700, 500] },
    { upto: 15000, suggest: 1400, prefills: [2300, 800, 500] },
    { upto: 20000, suggest: 1800, prefills: [3000, 900, 600] },
    { upto: 30000, suggest: 2800, prefills: [5000, 1700, 900] },
    { upto: 40000, suggest: 3800, prefills: [5000, 1800, 1000] },
    { upto: 50000, suggest: 4800, prefills: [7000, 1900, 1000] },
    { upto: 100000, suggest: 6000, prefills: [8000, 4800, 1800] },
    { upto: Infinity, suggest: 7000, prefills: [10000, 5000, 2000] },
  ]

  static suggest(amount: number) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.defaults.find((e) => e.upto >= amount)!.suggest
  }

  static prefills(amount: number) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.defaults.find((e) => e.upto >= amount)!.prefills
  }

  static appliesTo({ receiverType, receiverId }: { receiverType: string; receiverId: number | string }) {
    return (
      (receiverType === 'FundraisingEvent' &&
        [33420, 33575, 33581, 34721, 36081, 36177, 36304].includes(parseInt(String(receiverId)))) ||
      (receiverType === 'Project' && parseInt(String(receiverId)) === 78009)
    )
  }
}
